import { gql } from '@apollo/client';

/**
 * Mutation to create a new work order expense
 */
export const CREATE_WORK_ORDER_EXPENSE = gql`
  mutation CreateWorkOrderExpense($input: CreateWorkOrderExpenseInput!) {
    createWorkOrderExpense(input: $input) {
      id
      workOrderId
      title
      baseCost
      billedAmount
      isBillable
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
    }
  }
`;

/**
 * Mutation to update an existing work order expense
 */
export const UPDATE_WORK_ORDER_EXPENSE = gql`
  mutation UpdateWorkOrderExpense($id: ID!, $input: UpdateWorkOrderExpenseInput!) {
    updateWorkOrderExpense(id: $id, input: $input) {
      id
      workOrderId
      title
      baseCost
      billedAmount
      isBillable
      updatedAt
    }
  }
`;

/**
 * Mutation to delete a work order expense
 */
export const DELETE_WORK_ORDER_EXPENSE = gql`
  mutation DeleteWorkOrderExpense($id: ID!) {
    deleteWorkOrderExpense(id: $id)
  }
`;

